import type { StatusTone } from '../../../ui-kit';
import type { CwRunCard } from '../../../services/carrierWebsiteService';

/** The chip a run wears in the list and on its own page. */
export function runChip(run: Pick<CwRunCard, 'status' | 'stage'>): { tone: StatusTone; label: string; pulse?: boolean } {
  switch (run.status) {
    case 'working': return { tone: 'neutral', label: run.stage, pulse: true };
    case 'ready': return { tone: 'neutral', label: run.stage };
    case 'waiting':
    case 'stuck':
    case 'paused': return { tone: 'warning', label: run.stage };
    case 'stopped':
    case 'bound': return { tone: 'good', label: run.stage };
    case 'blocked': return { tone: 'bad', label: run.stage };
    default: return { tone: 'neutral', label: run.stage };
  }
}

/** "$1,268.40". */
export function money(value: number | null, currency: 'USD' | 'INR' = 'USD'): string {
  if (value == null) return '—';
  const shown = value.toLocaleString(currency === 'INR' ? 'en-IN' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${currency === 'INR' ? '₹' : '$'}${shown}`;
}
